import { AxiosError } from 'axios';

const getAction = (method: string | undefined) => {
  switch (method?.toLocaleLowerCase()) {
    case 'post':
    case 'put':
      return 'submitting';
    case 'delete':
      return 'removing';
    default:
      return 'retrieving';
  }
};

export const getFriendlyError = (
  error: { config?: { method?: string } } | null,
  descriptor: string,
  action?: string,
): string | undefined => {
  if (error) {
    const { config } = error;
    return `Error ${action || getAction(config?.method)} ${descriptor}`;
  }
  return undefined;
};

export const getFriendlyLoginError = (error: AxiosError | null): string | undefined => {
  if (error) {
    switch (error.response?.status) {
      case 401:
        return 'login.steps.passwordOrOTP.toasts.incorrectPassword';
      default:
        return typeof error.response?.data === 'string'
          ? error.response?.data
          : (error.response?.data as any)?.error_description || error.response?.statusText;
    }
  }
  return undefined;
};

export const getFriendlyNetworkError = (error: AxiosError | null): string | undefined => {
  if (error) {
    const isNetworkError = error.message.includes('Network Error');
    if (isNetworkError) {
      return 'login.toasts.networkError';
    }
  }
  return undefined;
};

export const getFriendlyRateLimitError = (error: AxiosError | null): string | undefined => {
  if (error) {
    const isCorsError = error?.isAxiosError && error?.response === undefined;
    const isRateLimitExceededError = isCorsError || error.response?.status === 429;
    if (isRateLimitExceededError) {
      return 'login.toasts.rateLimitExceeded';
    }
  }
  return undefined;
};

export const getFriendlyIsExistingUserError = (error: AxiosError | null): string | undefined => {
  const localePrefix = 'login.steps.emailOrPhone.toasts';
  if (error) {
    const networkError = getFriendlyNetworkError(error);
    if (networkError) return networkError;
    const rateLimitExceededError = getFriendlyRateLimitError(error);
    if (rateLimitExceededError) return rateLimitExceededError;
    switch (error.response?.status) {
      case 409:
        return `${localePrefix}.multipleUsersFound`;
      case 404:
        return `${localePrefix}.userNotFound`;
      case 400:
        return `${localePrefix}.badRequest`;
      default:
        return 'login.toasts.defaultError';
    }
  }
  return undefined;
};

export const getFriendlySendOtpError = (error: AxiosError | null): string | undefined => {
  if (error) {
    const rateLimitExceededError = getFriendlyRateLimitError(error);
    if (rateLimitExceededError) return rateLimitExceededError;
    switch (error.response?.status) {
      case 400:
        return 'login.steps.selectOTPChannel.toasts.invalidIdentifier';
      default:
        return 'login.toasts.defaultError';
    }
  }
  return undefined;
};
